module.exports = __webpack_public_path__ + "static/media/otras_entidades.558c96ce.png";